// extracted by mini-css-extract-plugin
export default {"container":"S01_Backward_container__tYVlf","limiter":"S01_Backward_limiter__p2y0p","arrowBack":"S01_Backward_arrowBack__s69Jb"};